export function makeId() {
  return crypto.randomUUID();
}

/**
 * Deterministic 6-digit numeric ID derived from a UUID.
 * Always returns exactly 6 decimal digits (000000–999999).
 * Used for human-readable order labels: "Заявка 034521".
 */
export function numericOrderId(id: string): string {
  const hex = id.replace(/-/g, '').slice(0, 12);
  const n = parseInt(hex, 16) % 1_000_000;
  return String(n).padStart(6, '0');
}
